import { queryOptions } from '@tanstack/react-query'
import { apiGet } from './client'

/**
 * Pagina `/settings` (directorul setarilor) - `settings/All_settings::index`
 * -> GET /settings/directory. Lista vine DEJA filtrata pe drepturi, rand cu rand.
 */
export type DirectoryScreen = { url: string; name: string; about: string; zone: string }

export type SettingsDirectoryPage = {
  pageTitle: string
  total: number
  groups: { name: string; screens: DirectoryScreen[] }[]
}

export const settingsDirectoryQuery = queryOptions({
  queryKey: ['settings', 'directory'],
  queryFn: () => apiGet<SettingsDirectoryPage>('/settings/directory'),
})
